module.exports = __webpack_public_path__ + "pc-top-assets/img/logo.f9fffad6.svg";